module.exports = __webpack_public_path__ + "img/11.138b9c9d.png";